module.exports = __webpack_public_path__ + "img/s03.327bd0c8.png";